import React from 'react';

export interface IColumnProps extends React.HTMLProps<HTMLTableCellElement> {
  isHeader?: boolean;
}

/**
 * Base component for for truth table column.
 * HTML doesn't contain ability to define column so we consider th, td as columns to apply styles.
 *
 * Previously, we used it to resize columns when implementing position: sticky for header.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function Column({ className, isHeader, ...otherProps }: IColumnProps) {
  const Column = isHeader ? 'th' : 'td';
  return <Column className={className} {...otherProps} />;
}
